import React, { Component } from 'react';
import CustomFineUploader from '../components/CustomFineUploader';

class Upload extends Component {

    render() {
        return (
            <CustomFineUploader />
        );
    }
}
export default Upload;


// WEBPACK FOOTER //
// ./src/containers/Upload.js